import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShowcaseBlockHidden.meta';

export type UseTrackShowcaseBlockHiddenParams = {
  hidden: boolean;
};

export const useTrackShowcaseBlockHidden = () => {
  const { track } = useAnalyticsUtilities();

  const trackShowcaseBlockHidden = useCallback(
    (params: UseTrackShowcaseBlockHiddenParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackShowcaseBlockHidden };
};
